import styled from 'styled-components'
import { colors } from '../../../styles/vars/colors.style'
import { mq } from '../../../styles/vars/media-queries.style'
import { easings } from '../../../styles/vars/easings.style'

export const MapHeader = styled.div`
  display: block;
  position: relative;
  text-align: center;

  ${mq.desk} {
    display: block;
  }

  &:before {
    background-color: ${colors.darkBlue};
    content: '';
    height: 0.1rem;
    left: 0;
    opacity: ${props => (props.inView ? 0.2 : 1)};
    position: absolute;
    right: 0;
    top: 0;
    transform: scaleX(${props => (props.inView ? 1 : 0)});
    transform-origin: 0% 0%;
    transition: transform 2s ${easings.inOut.quart},
      opacity 2s ${easings.inOut.quart};
  }
`

export const MapText = styled.div``
